import src from "IMAGE";
export default { src, width: 132, height: 21, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AFdKG0tEOhU4PzYTNEg9FjtNQhhCRDoVOCwmEzIXFhY7b7kGLofXV3wAAAAASUVORK5CYII="};
